import { createContext, useContext, useMemo, type ReactNode } from "react";
import { CommandClient } from "@forcebase-ai/api-client";
import { API_ORIGIN } from "./config";
import { useAppAuth } from "./auth";

const ApiContext = createContext<CommandClient | null>(null);

export function ApiProvider({ children }: { children: ReactNode }) {
  const { getToken } = useAppAuth();
  const client = useMemo(() => new CommandClient({ baseUrl: API_ORIGIN, getToken }), [getToken]);
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): CommandClient {
  const c = useContext(ApiContext);
  if (!c) throw new Error("useApi must be used within an ApiProvider");
  return c;
}
